import { Environment } from './environment.interface';

export const environment: Environment = {
  appEnv: 'dev',
  bugHerdApiKey: 'wq9uyyhzzwjzqgtdcfe3sg',
  webSocketUrl: 'wss://navigate.ws.dev.navigate.ets-compass-nonprod.c.ets.org',
  navigateApiUrl: 'https://navigate.api.dev.navigate.ets-compass-nonprod.c.ets.org',
  surveysApiUrl: 'https://surveys.api.dev.navigate.ets-compass-nonprod.c.ets.org',
  usersApiUrl: 'https://users.api.dev.navigate.ets-compass-nonprod.c.ets.org',
  careerSurveyUuid: '3b5c3304-f1b9-45be-a173-a8bb78b9e184',
  jwtCookieName: 'oidc_jwt',
  loginUrl: 'https://dev.navigate.ets-compass-nonprod.c.ets.org/login',
  signUpUrl: 'https://dev.navigate.ets-compass-nonprod.c.ets.org/signup',
  edgeAssessments: {
    communication: {
      id: '8b870d9c-45e2-4d37-8227-c6c220a93ee9',
      url: 'https://dev.ets-corpsoln-edge-nonprod.c.ets.org/c35c/dashboard/communication',
    },
    behavioral: {
      id: 'c86c503f-b967-4a5d-aaaf-3215f644d4bc',
      url: 'https://dev.ets-corpsoln-edge-nonprod.c.ets.org/c35c/dashboard/behavioral',
    },
  },
  googleMapsApiKey: 'AIzaSyCfHvqAqsuJi4kdREjy1se2Ui-0PCZce7A',
  segmentWriteKey: 'u9N2cmQuiBE0eNsMDXoDxZ48iYVH5GYN',
  segmentProxyEnabled: true,
  segmentCdnPath: '/segment-cdn',
  segmentApiPath: '/segment-api',
}
